"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconGoogleDrive = function IconGoogleDrive(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "1 -46 511.99993 511",
    className: (0, _classnames.default)('Icon', 'IconGoogleDrive', className),
    style: style
  }, _react.default.createElement("path", {
    d: "m428.597656 419.984375 83.402344-119.144531-176.515625-300.339844h-158.96875l-176.515625 300.339844 83.402344 119.144531zm-15.601562-29.964844h-298.761719l45.722656-74.90625h305.476563zm-77.589844-104.871093h-157.160156l77.785156-127.4375zm132.617188 0h-97.316407l-158.636719-254.683594h106.269532zm-282.5625-240.734376 52.839843 84.835938-149.914062 245.605469-52.800781-75.429688zm0 0"
  }));
};

var _default = IconGoogleDrive;
exports.default = _default;